export default {
  "pl": {
    "milestone": {
      "actions": {
        "create": "Utwórz kamień milowy",
        "delete_milestones": "Usuń kamień milowy | Usuń {count} kamieni milowych",
        "new": "Dodaj nowy kamień milowy"
      },
      "labels": {
        "empty_state_subtitle": "Kamienie milowe sprawiają, że proces budowy jest bardziej przejrzysty dla nabywców domów",
        "empty_state_title": "Utwórz nowy kamień milowy",
        "future_milestones": "Przyszłe kamienie milowe",
        "milestone": "Kamień milowy",
        "milestone_name": "Nazwa kamienia milowego",
        "milestone_unit_count": "0 jednostek | 1 jednostka | {count} jednostek",
        "new_milestone": "Nowy kamień milowy",
        "past_milestones": "Przeszłe kamienie milowe",
        "search_empty_state": "Nie utworzono jeszcze kamieni milowych. Kliknij tutaj żeby zacząć",
        "units_without_milestone": "1 jednostka bez kamienia milowego | {count} jednostek bez kamienia milowego",
        "warning_delete": "Jeśli usuniesz kamień milowy przypisany do jednostki, klient straci z pola widzenia, na jakim etapie znajduje się jego jednostka. Pamiętaj, aby przypisać tym jednostkom nowy kamień milowy!"
      },
      "toasts": {
        "create_success": "Pomyślnie utworzono kamień milowy",
        "update_success": "Kamienie milowe zostały pomyślnie zaktualizowane"
      },
      "validation": {
        "needName": "Należy podać nazwę"
      }
    }
  }
}
